import React, { useEffect } from "react";
import { UsersModalLayoutJSON } from "../Json/UsersLayoutJson";
import { renderElement } from "../../../../../Components/Common/FormRendererV2/Renderer";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getRoles, getUserData, updateUser } from "../UserService";
import {
  resetFormState,
  setSelectValidError,
  verifyModal,
} from "../../../../../slices/common/reducer";
import { Form } from "react-bootstrap";
import { CardBody } from "reactstrap";
import CommonButton from "../../../../../Components/Common/CommonButton/CommonButton";
import ConfirmationModal from "../Modal/ConfirmationModal";
import { setSelectedUser } from "../../../../../slices/header/headerSlice";
import {
  checkButtonAccess,
  getEntityType,
} from "../../../../../Utils/CommonUtils";

const Details = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigator = useNavigate();
  const usersFieldJson = useSelector((state) => state.users.usersFieldJson);
  const formState = useSelector((state) => state.common.formRendererState);
  const UserUpdateId = useSelector((state) => state.users.userEdit.id);
  const data = useSelector(
    (state) => state.agMember.selectedAgMember.detailsData
  );
  const verifyShow = useSelector((state) => state.common.verifyShow);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const editMode = !!params.id;
  const detailsData = useSelector(
    (state) => state.users.selectedUser.detailsData
  );
  const entityType = getEntityType();
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const organizationId = selectedUser.organizationid;

  useEffect(() => {
    if (params.id) {
      getUserData(params.id, "AGSU", usersFieldJson);
    }
  }, [params.id]);

  useEffect(() => {
    getRoles(selectedUser.entitytype, organizationId, usersFieldJson);
  }, []);

  const handleCancel = () => {
    dispatch(resetFormState());
    dispatch(setSelectValidError(false));
    navigator("/team/user");
  };

  const updateClickHandler = (e) => {
    e.preventDefault();
    dispatch(verifyModal(true));
  };

  const confirmUpdate = () => {
    if (formState) {
      dispatch(setSelectValidError(false));
      updateUser(formState, params.id, "AGSU", navigator);
    } else {
      dispatch(setSelectValidError(true));
    }
    dispatch(verifyModal(false));
  };

  return (
    <div>
      <Form onSubmit={updateClickHandler}>
        <CardBody>
          <div className="selected-tab-bottom-content">
            {UsersModalLayoutJSON.map((element) => (
              <div key={element.elementid}>
                {element.child.map((child) =>
                  renderElement(child, usersFieldJson, formState)
                )}
              </div>
            ))}
          </div>
          <div className="form-footer">
            <CommonButton
              update={true}
              // handleSubmit={updateClickHandler}
              handleCancel={handleCancel}
              checkAccess={checkButtonAccess("EDIT", "TEM_USR")}
            />
          </div>
          {verifyShow && <ConfirmationModal confirmUpdate={confirmUpdate} />}
        </CardBody>
      </Form>

      {/* </form> */}
    </div>
  );
};

export default Details;
